import { useEffect } from "react";

import MUIAutoComplete from "@mui/material/Autocomplete";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";

import useLocalization from "../../hooks/useLocalization";

const AutoComplete = ({
  id,
  label,
  value,
  onChange,
  items,
  width,
  disabled,
}) => {
  const { getLabel } = useLocalization();

  const handleChange = (e, newvalue) => {
    if (!newvalue) {
      onChange(null);
    } else {
      onChange(newvalue.id);
    }
  };

  const getValue = () => {
    if (!value) return "";

    for (const item of items) {
      if (item.id === value) {
        return item;
      }
    }
    return "";
  };

  return (
    <Box sx={{ width: width ? width : "200px" }}>
      <Box sx={{ paddingLeft: "6px", paddingRight: "6px" }}>
        <Typography sx={{ fontSize: "10px", fontWeight: "bold" }}>
          {getLabel(label)}
        </Typography>
      </Box>

      <MUIAutoComplete
        id={id}
        size="small"
        value={getValue()}
        onChange={handleChange}
        options={items}
        renderOption={(props, option) => (
          <li
            {...props}
            key={option.key}
          >
            {option.name}
          </li>
        )}
        sx={{
          "& .MuiOutlinedInput-root": {
            padding: "6px",
            fontSize: "12px",
          },
        }}
        getOptionLabel={(options) => options.name || ""}
        renderInput={(parms) => <TextField {...parms} />}
        disabled={disabled}
      ></MUIAutoComplete>
    </Box>
  );
};

export default AutoComplete;
